import { default as FileSizeFilterName, FileSizeFilter } from '@agent/agent-interface/contact-view/chat/filters/file-size.filter';
import {
  ContactExchangeContainer,
  default as contactExchangeContainerName,
} from '@agent/agent-interface/contact-view/contact-exchange-container.component.ajs';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { AppConf } from '@contact/upgrade';

import { Chat, ChatIadvize, Mail, Phone, SocialNetwork, Video, Visio } from './';
import {
  ContactConfirmAppointmentDeletion,
  default as contactConfirmAppointmentDeletionName,
} from './contact-confirm-appointment-deletion.component.ajs';
import { ContactDisplayQualification, default as contactDisplayQualificationName } from './contact-display-qualification.component.ajs';
import { ContactForwardComponent } from './contact-forward.component';
import { ContactInProcess, default as contactInProcessName } from './contact-in-process.component.ajs';
import { ContactInfo, default as contactInfoName } from './contact-info.component.ajs';
import { ContactPreviousExchange, default as contactPreviousExchangeName } from './contact-previous-exchange.component.ajs';
import { ContactQualificationComponent } from './contact-qualification.component';
import { ContactQualification, default as contactQualificationName } from './contact-qualification.component.ajs';
import { ContactTreatment, default as contactTreatmentName } from './contact-treatment.component.ajs';
import { ContactViewHistoPopin, default as contactViewHistoPopinName } from './contact-view-histo-popin.component.ajs';
import { ContactViewLayout, default as contactViewLayoutName } from './layout/contact-view-layout.component.ajs';

export default module('contact.agent.contact-view', [Chat, ChatIadvize, Mail, Phone, SocialNetwork, Video, Visio])
  .component(contactViewLayoutName, new ContactViewLayout())
  .component(contactConfirmAppointmentDeletionName, new ContactConfirmAppointmentDeletion())
  .component(contactDisplayQualificationName, new ContactDisplayQualification())
  .component(contactQualificationName, new ContactQualification())
  .component(contactInProcessName, new ContactInProcess())
  .component(contactExchangeContainerName, new ContactExchangeContainer())
  .component(contactInfoName, new ContactInfo())
  .component(contactPreviousExchangeName, new ContactPreviousExchange())
  .component(contactTreatmentName, new ContactTreatment())
  .component(contactViewHistoPopinName, new ContactViewHistoPopin())
  // DOWNGRADED
  .factory('appConf', downgradeInjectable(AppConf) as any)
  .directive('cngContactForward', downgradeComponent({ component: ContactForwardComponent }) as angular.IDirectiveFactory)
  .directive('cngContactQualification', downgradeComponent({ component: ContactQualificationComponent }) as angular.IDirectiveFactory)
  .filter(FileSizeFilterName, FileSizeFilter.factory()).name;
